const Validation = (fields, verificationType) => {
    let errors = {};  

    if(verificationType === 'verifycode'){
        for ( let key in fields){
            if(fields[key].length < 1) errors[key] = fields[key].length < 1;
        }
        
    }else{
        for ( let key in fields){
            if(fields[key].type === 'text' && fields[key].required){
                if(fields[key].value.length < 1) errors[key] = fields[key].value.length < 1;
            }
            if(fields[key].type === 'radio' && fields[key].required){
                if(fields[key].value.length < 1) errors[key] = fields[key].value.length < 1;
            }
            if(fields[key].type === 'email' && fields[key].required){
                if(!/\S+@\S+\.\S+/.test(fields[key].value)) errors[key] = !/\S+@\S+\.\S+/.test(fields[key].value);
            }
            if(fields[key].type === 'date' && fields[key].required){
                let d = new Date(fields[key].value);
                if(!d.getTime()){
                    errors[key] = true ;
                }               
            }
            if(fields[key].type === 'phone' && fields[key].required){
                console.log(fields[key].type)
                if(fields[key].value.length < 7 || fields[key].value.length > 13) errors[key] = fields[key].value.length < 7 || fields[key].value.length > 13 ;
            }
            if(fields[key].type === 'accountnumber' && fields[key].required){
                if(isNaN(fields[key].value) || fields[key].value.length < 4 || fields[key].value.length > 9) errors[key] = isNaN(fields[key].value) || fields[key].value.length < 4 || fields[key].value.length > 9 ;
                // isNaN(number) || (number.length < 4 || number.length > 9
                // console.log( )
            }
            if(fields[key].type === 'onwername' && fields[key].required){
                if(fields[key].value.length < 4) errors[key] = fields[key].value.length < 4 ;
                // isNaN(number) || (number.length < 4 || number.length > 9
                // console.log( )
            }
            if(fields[key].type === 'bankcode' && fields[key].required){
                if(isNaN(fields[key].value) || fields[key].value.length !== 6) errors[key] = isNaN(fields[key].value) || fields[key].value.length !== 6 ;
                console.log(isNaN(fields[key].value) || fields[key].value.length !== 6)
                // console.log( )
            }
        }
    }
    console.log(errors)
    errors = Object.keys(errors).length < 1 ? false : errors;
    return errors

    
}

export default Validation;
